import { IconCircleCheck, IconPlus } from "@tabler/icons-react";
import {
	Col,
	Form,
	Image,
	Row,
	Spin,
	Tooltip,
	Typography,
	message,
} from "antd";
import { useForm } from "antd/es/form/Form";
import TextArea, { TextAreaRef } from "antd/es/input/TextArea";
import CommentButton from "./CommentButton";
import CommentInput from "./CommentInput";
import {
	useEditCommentMutation,
	useEditQaMutation,
	useEditReviewMutation,
} from "features/comment/service/comment.service";
import {
	CommentJsonAddEdit,
	TypeList,
} from "features/comment/types/comment.type";
import React, {
	useCallback,
	useEffect,
	useMemo,
	useRef,
	useState,
} from "react";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { ErrorComment } from "features/comment/types/comment.type";
import { useTranslation } from "react-i18next";
import {
	selectCallbackUrl,
	selectToken,
	selectUser,
	setCallbackUrl,
	toggleShowLogin,
} from "features/auth/AuthSlice";
import { User } from "features/auth/types/auth.type";
import FileModel from "common/models/FileModel";
import usePostCommentEndpoint from "Hooks/usePostCommentEndpoint";
import CommentRate from "./CommentRate";
import { useLogoutMutation } from "features/auth/service/auth.service";
import { LoadingOutlined } from "@ant-design/icons";
import CommentModel from "common/models/CommentModel";
import ButtonUpload2 from "./ButtonUpload2";
import FileCollection from "common/collections/FileCollection";
import {
	selectDetailProduct,
	setListComment,
	setListQa,
	setListReview,
} from "features/comment/CommentSlice";
import { FileJson } from "common/types/File";
import Helper from "common/utils/helper";
import { min } from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import CustomerConstants from "common/constants/Customer";
import Setting from "setting";
import MessengerIcon from "library/icons/MessengerIcon";
import SendIcon from "library/icons/comment/SendIcon";
type Props = {
	item_id: string;
	item_type: string;
	parent_id?: number;
	idEditing?: number;
	handleSuccess?: (type: string) => void;
	handleCancelModal: () => void;
	form_type: TypeList;
	style?: React.CSSProperties;
	idForm?: string;
};

const CommentForm = ({
	item_id,
	item_type,
	parent_id,
	idEditing = 0,
	handleSuccess,
	style,
	form_type,
	handleCancelModal,
	idForm = "",
}: Props) => {
	const [form] = useForm();
	const { t } = useTranslation();
	const [messageApi, contextHolder] = message.useMessage();
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	//////////////////////////
	const modelComment = useAppSelector((state) => state.comment.model);
	const token = useAppSelector(selectToken);
	const userInfor = useAppSelector(selectUser);
	const detailProduct = useAppSelector(selectDetailProduct);
	const calbacklink = useAppSelector(selectCallbackUrl);

	//////////////////////////
	const [loading, setLoading] = useState<boolean>(false);
	const [error, setError] = useState<ErrorComment>();
	const [user, setUser] = useState<User>();
	const [imageIds, setImageIds] = useState<number[]>([]);
	const [imageRes, setImageRes] = useState<FileJson[]>([]);
	const textAreaRef = useRef<TextAreaRef>(null);
	const [showLogin, setShowLogin] = useState<boolean>(false);
	const [textDetail, setTextDetail] = useState("");
	const windowWidth = useRef(window.innerWidth);

	////////////////////////////////
	const [text, setText] = useState("Hello, World!");
	const [isEditings, setIsEditings] = useState(false);

	const handleDoubleClick = () => {
		setIsEditings(true);
	};

	const handleBlur = () => {
		setIsEditings(false);
	};

	const handleChange = (e: any) => {
		setText(e.target.value);
	};
	//////////////////////////
	const initialValue = useMemo(() => {
		if (userInfor !== null) {
			if (modelComment !== null) {
				return {
					detail: modelComment.detail,
					rate: modelComment.rate,
					name: modelComment.name,
					email: modelComment.email,
					title: modelComment.title,
					images: FileModel.convertToUploadFiles(
						new FileCollection().itemsFromJson(modelComment.images)
					),
				};
			} else {
				return {
					// email: userInfor.company?.customer?.email,
					// name: userInfor.user?.full_name,
					title: "",
					email: "",
					name: "",
					rate: 5,
				};
			}
		} else {
			return {
				title: "",
				email: "",
				name: "",
				rate: 5,
			};
		}
	}, [userInfor, token]);

	const { add, addResult } = usePostCommentEndpoint({ type: form_type });
	const [editComment, editCommentResult] = useEditCommentMutation();
	const [editReview, editReviewRult] = useEditReviewMutation();
	const [editQa, editQaResult] = useEditQaMutation();
	const [logout, logoutResult] = useLogoutMutation();

	//////////////////////////
	const typeText = useMemo((): string => {
		let text = "";

		switch (form_type) {
			case "comment":
				text = "bình luận";
				break;
			case "review":
				text = "đánh giá";
				break;
			default:
				text = "câu hỏi";
				break;
		}
		return text;
	}, [form_type]);

	const typeLableDetail = useMemo((): string => {
		let text = "";

		switch (form_type) {
			case "comment":
				text = "";
				break;
			case "review":
				text = "Mô tả";
				break;
			default:
				text = "";
				break;
		}
		return text;
	}, []);

	const { linkImageProduct, title, gender, vendor, handle } = detailProduct;

	//////////////////////////
	// Function

	const doPredata = useCallback(
		(formData: CommentJsonAddEdit): CommentJsonAddEdit => {
			const newFormData = {
				...formData,
				rate: formData.rate ? formData.rate : 0,
				images: imageIds.join(","),
				customer_id: userInfor ? userInfor.company.customer?.id : undefined,
				item_id: item_id,
				item_type: item_type,
				parent_id: parent_id && parent_id,
				phone: formData.phone,
				name:
					token !== null
						? userInfor
							? userInfor.user.full_name
							: ""
						: formData.name,
				email: formData.email ? formData.email.trim() : undefined,
				item_detail: JSON.stringify({
					data_image: linkImageProduct,
					data_title: title,
					data_gender: gender,
					data_vendor: vendor,
					data_handle: handle,
				}),
			};

			return Helper.convertParams(newFormData);
		},
		[parent_id, token, detailProduct, imageIds]
	);

	const onSubmit = async (formData: any) => {
		form.validateFields(["image"]);
		setLoading(true);
		try {
			const payload = isEditing
				? form_type === "comment"
					? await editComment(
							doPredata({ ...formData, id: idEditing })
					  ).unwrap()
					: form_type === "review"
					? await editReview(doPredata({ ...formData, id: idEditing })).unwrap()
					: await editQa({ ...formData, id: idEditing })
				: await add(doPredata(formData)).unwrap();
			if (payload) {
				if (!token) {
					if (!isEditing) {
						handleUpdateState({
							form_type: form_type,
							res: payload,
							formData: doPredata({
								...formData,
								parent_id: parent_id ? parent_id : 0,
							}),
						});
						// form_type === "review" && handleUpdateState({form_type:"review"});
						// form_type === "qa" && handleUpdateState();
						// form_type === "comment" && handleUpdateState();
					}
				}
				form.resetFields();
				handleSuccess && handleSuccess(form_type);
				setImageIds([]);
				setImageRes([]);
				setTextDetail("");
			}

			form.resetFields(["email", "name", "detail"]);
		} catch (err: ErrorComment | any) {
			setError(err.error);
			messageApi.open({
				content: t(
					`comment:errors.${err.data ? err.data.error[0] : err.status}`
				),
				duration: 4,
				type: "error",
			});
			setLoading(false);
		}
		setLoading(false);
	};

	const handleUpdateState = ({
		form_type,
		res,
		formData,
	}: {
		form_type: TypeList;
		res: any;
		formData: CommentJsonAddEdit;
	}) => {
		form_type === "comment" &&
			dispatch(
				setListComment({
					data: [
						{
							...CommentModel.getDefaultData(),
							id: Number(res.comment_id),
							detail: formData.detail || "",
							name: formData.name,
							rate: formData.rate || 5,
							phone: formData.phone || 0,
							email: formData.email || "",
							date_created: Math.floor(Date.now() / 1000),
							images: [],
							parent_id: formData.parent_id || 0,
						},
					],
					type: "one",
				})
			);
		form_type === "review" &&
			dispatch(
				setListReview({
					data: [
						{
							...CommentModel.getDefaultData(),
							id: Number(res.comment_id),
							detail: formData.detail || "",
							name: formData.name,
							rate: formData.rate || 5,
							email: formData.email || "",
							phone: formData.phone || 0,
							date_created: Math.floor(Date.now() / 1000),
							images: imageRes,
							title: formData.title || "",
						},
					],
					type: "one",
				})
			);
		form_type === "qa" &&
			dispatch(
				setListQa({
					data: [
						{
							...CommentModel.getDefaultData(),
							id: res.id,
							detail: formData.detail || "",
							name: formData.name,
							phone: formData.phone || 0,
							email: formData.email || "",
							date_created: Math.floor(Date.now() / 1000),
						},
					],
					type: "one",
				})
			);
	};

	const isEditing = useMemo(() => {
		if (idEditing && idEditing > 0) {
			return true;
		}
		return false;
	}, [idEditing]);

	const handleUploadSuccess = (
		newFiles: FileModel[],
		type: "add" | "delete"
	) => {
		if (newFiles) {
			const newFileJson = newFiles.map((i) => i.toJson());
			const newImagesId = newFiles.map((i) => i.id);
			if (type === "add") {
				const uniqueImageId = [...imageIds, ...newImagesId].reduce(
					(acc: number[], item) => {
						if (!acc.includes(item)) {
							acc.push(item);
						}

						return acc;
					},
					[]
				);

				const uniqueFileJson = [...imageRes, ...newFileJson].reduce(
					(acc: FileJson[], item) => {
						if (acc.filter((f) => f.id === item.id).length === 0) {
							acc.push(item);
						}
						return acc;
					},
					[]
				);

				setImageIds(uniqueImageId);
				setImageRes((prev) => [...uniqueFileJson]);
			} else {
				setImageIds(newImagesId);
				setImageRes(newFileJson);
			}
		}
	};

	const handleLogin = async () => {
		if (!userInfor) {
			dispatch(setCallbackUrl(window.location.href));
			if (Setting.isBeta()) {
				window.location.href = "https://namperfume.net/pages/account";
			} else {
				window.location.href = "/";
			}
		} else {
			try {
				const res = await logout(1).unwrap();
				if (res) {
					form.setFieldsValue({ email: null, name: null });
					messageApi.open({
						content: "Đăng xuất thành công",
						duration: 4,
						type: "success",
					});
				}
			} catch (error) {}
		}
	};

	const handleRateChange = (value: number) => {
		form.setFieldValue("rate", value);
	};

	const handleSwitchUserSuccess = async () => {
		setShowLogin(false);
		messageApi.open({
			content: "Đổi tài khoản  thành công",
			duration: 4,
			type: "success",
		});
	};

	const handleBeforeLoginSuccess = async () => {
		// try {
		//   const res = await logout(1).unwrap();
		//   if (res) {
		//     // form.setFieldsValue({ email: null, name: null });
		//   }
		// } catch (error) {}
	};

	//////////////////////////
	// Effect
	useEffect(() => {
		if (userInfor) {
			setUser(userInfor.user);
			form.setFieldsValue({
				email: userInfor?.company?.customer?.email,
				name: userInfor?.user.full_name,
			});
		} else {
			setUser(undefined);
		}
	}, [userInfor]);

	//////////////////////////
	// child Component

	const maxLengthText: number = useMemo(() => {
		if (window !== undefined) {
			if (windowWidth.current > 768) {
				return 71;
			} else if (windowWidth.current <= 450) {
				return 35;
			} else {
				return 55;
			}
		} else {
			return 35;
		}
	}, [window.innerWidth]);

	const DetailRender = useMemo(() => {
		switch (form_type) {
			case "comment":
				return (
					<Form.Item
						name="detail"
						className="input_detail_wrap"
						style={{ marginBottom: 0 }}
						rules={[
							{
								required: true,
								message: `Vui lòng nhập ${typeText}`,
							},
						]}>
						{idEditing && idEditing > 0 ? (
							<TextArea
								id="form_textarea_edit"
								className="textArea_webkitscroll_hide_edit"
								placeholder={`Viết ${typeText} của bạn ở đây...`}
								// autoSize={{ minRows: 1, maxRows: 4 }}
								rows={4}
								style={{
									paddingRight: "16px",
									width: "100%",
									paddingLeft: "16px",
								}}
								maxLength={800}
								showCount={{
									formatter(args) {
										return (
											<span style={{ marginRight: 8 }}>
												{args.count}/{args.maxLength} ký tự
											</span>
										);
									},
								}}
								bordered={true}
								ref={textAreaRef}
								defaultValue={initialValue.detail}
								onChange={(e) => {
									setTextDetail(e.target.value);
								}}></TextArea>
						) : (
							<div
								style={{
									minHeight: "34px",
									position: "relative",
									display: "flex",
									border: "1px solid #D8D7D8",
									alignItems: "center",
									gap: 4,
									borderRadius: 4,
									width: "auto",
									flexDirection:
										maxLengthText <= textDetail.length ? "column" : "row",
								}}>
								<TextArea
									id="form_textarea"
									className="textArea_webkitscroll_hide"
									placeholder={`Viết ${typeText} của bạn ở đây...`}
									autoSize={{ minRows: 1, maxRows: 3 }}
									style={{ paddingRight: "16px", paddingLeft: "16px" }}
									maxLength={800}
									bordered={false}
									ref={textAreaRef}
									defaultValue={initialValue.detail}
									onChange={(e) => {
										setTextDetail(e.target.value);
									}}></TextArea>

								<div
									className={`${
										maxLengthText <= textDetail.length ? "detail_block" : ""
									}`}
									style={{
										cursor: "pointer",
										transform: "translateY(-4px)",
										height: "100%",
										display: "flex",
										textAlign: "center",
										alignItems: "center",
										gap: 8,
										float: "right",
										paddingRight: 8,
									}}
									onClick={() => {
										form.submit();
									}}
									onTouchEnd={() => {
										form.submit();
									}}>
									<span
										style={{
											color: "#898889",
											marginTop: 6,
											whiteSpace: "nowrap",
										}}>
										{textDetail.length}/800 Ký tự
									</span>
									<SendIcon></SendIcon>
									{/* <div
										className="comment_icon"
										id="comment_icon-send"
										style={{
											width: 24,
											height: 24,
											marginTop: 8,
											marginRight: 10,
										}}></div> */}
								</div>
							</div>
						)}

						{/* <Input.TextArea  rows={1} maxLength={800} showCount /> */}
						{/* <CommentInput
              placeholder="Viết bình luận của bạn ở đây"
              bordered={true}
              maxLength={800}
              showCount={true}
              name="detail"
              allowClear={true}
              style={{ marginBottom: 0 }}
              addonAfter={
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    form.submit();
                  }}
                  onTouchEnd={() => {
                    form.submit();
                  }}
                >
                  <div
                    className="comment_icon"
                    id="comment_icon-send"
                    style={{ width: 24, height: 24 }}
                  ></div>
                </span>
              }
              styleInput={{
                border: "1px solid #D8D7D8",
                borderRadius: 4,
                height: 44,
                marginTop: 4,
                whiteSpace: "pre-wrap",
                cursor: "text",
              }}
            ></CommentInput> */}
						{/* <span
              style={{
                border: "1px solid #D8D7D8",
                height: "30px",
                display: "inline-block",
                width: "100%",
                borderRadius: 4,
              }}
              onDoubleClick={handleDoubleClick}
              contentEditable={true}
              content="sdf"
              onBlur={handleBlur}
            >
              {text}
            </span> */}
					</Form.Item>
				);
				break;

			default:
				return (
					<Form.Item
						name="detail"
						className="form_detail_wrapper"
						// initialValue={"alo"}
						// prefixCls="alo"

						label={
							form_type === "review" ? (
								<p
									style={{
										fontWeight: 600,
										fontSize: 14,
										color: "#3A393A",
										margin: 0,
									}}>
									{typeLableDetail}
								</p>
							) : null
						}
						rules={[
							{
								required: form_type === "review" ? false : true,
								message: `Vui lòng nhập ${typeText}`,
							},
						]}>
						<div
							id="ss"
							style={{
								border: "1px solid rgb(216, 215, 216)",
								paddingBottom: "22px",
								borderRadius: 4,
							}}>
							<TextArea
								id="review_textarea"
								name="detail"
								bordered={false}
								styles={{
									textarea: { resize: "none", marginBottom: 2 },
									count: { transform: "translateY:-30px" },
								}}
								rows={3}
								defaultValue={initialValue.detail}
								placeholder={
									form_type === "qa"
										? "Viết câu hỏi của bạn ở đây"
										: "Viết mô tả của bạn ở đây"
								}
								showCount={{
									formatter(args) {
										return (
											<span style={{ marginRight: 8 }}>
												{args.count}/{args.maxLength} ký tự
											</span>
										);
									},
								}}
								maxLength={800}
								style={{ margin: 0 }}
							/>
						</div>
					</Form.Item>
				);
				break;
		}
	}, [form_type, textDetail, modelComment, initialValue]);

	const isShowButtonSubmit = useMemo(() => {
		if (form_type === "comment" && idEditing <= 0) {
			return false;
		} else {
			return true;
		}
	}, []);
	// style
	const styles = {
		labelInput: {
			color: "#898889",
			fontWeight: 400,
			marginBottom: "0px",
			marginTop: "24px",
			// fontSize: "12px",
		},
		formItem: {
			padding: 0,
			marginBottom: 0,
		},
	};

	//////////////////////////
	return (
		<>
			<Form
				id={idForm}
				name="comment"
				layout="vertical"
				form={form}
				onFinish={onSubmit}
				initialValues={initialValue}
				style={style ? style : {}}>
				{contextHolder}
				<Spin spinning={loading}>
					<>
						{form_type === "review" && (
							<div style={{ marginBottom: 12 }}>
								<Row style={{ width: "100%" }}>
									<Col
										span={24}
										style={{
											borderBottom: "1px solid #D8D7D8",
											margin: "16px 0 0 0 ",
											paddingBottom: "16px",
										}}>
										<div id="image_product_wrapper">
											<div id="image_product">
												<Image
													src={detailProduct.linkImageProduct}
													alt="product-image"
													style={{
														objectFit: "cover",
													}}></Image>
											</div>
											<div
												id="detail_product"
												style={{
													display: "flex",
													flexDirection: "column",
													justifyContent: "center",
													height: "100%",
													gap: 8,
													maxHeight: "120px",
													overflowY: "hidden",
												}}>
												<span
													style={{
														margin: 0,
														minWidth: 20,
														maxWidth: 40,
														height: 14,
														background: "#FBE6F1",
														borderRadius: 4,
														padding: "2px 10px",
														display: "inline-flex",
														justifyContent: "center",
														alignItems: "center",
													}}>
													{detailProduct.gender}
												</span>

												<Typography.Text
													style={{
														fontSize: "12px",
														fontWeight: 500,
														color: "#3A393A",
														lineHeight: "18px",
													}}>
													{detailProduct.title}
												</Typography.Text>
												<Typography.Text
													style={{
														maxHeight: 52,
														overflow: "hidden",
														textOverflow: "ellipsis",
														fontSize: 12,
													}}>
													Thương hiệu:{" "}
													<span style={{ color: "#3A393A", fontWeight: 700 }}>
														{detailProduct.vendor}
													</span>
												</Typography.Text>
												{/* <div style={{ display: "flex", gap: 14 }}>
                          {detailProduct.gender && (
                            <span
                              style={{
                                height: 13,
                                width: "auto",
                                color: "#fff",
                                fontSize: 10,
                                borderRadius: 4,
                                background: "#3A393A",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "2px 10px",
                              }}
                            >
                              {detailProduct.gender}
                            </span>
                          )}
                          {detailProduct.vendor && (
                            <span
                              style={{
                                height: 13,
                                borderRadius: 4,
                                width: "auto",
                                fontSize: 10,
                                color: "#fff",
                                background: "#D72229",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "2px 10px",
                              }}
                            >
                              {detailProduct.vendor}
                            </span>
                          )}
                        </div> */}
											</div>
										</div>
									</Col>
								</Row>
							</div>
						)}
						{false && (
							<div
								id="confirm_title_account"
								style={{
									display: "inline-block",
									whiteSpace: "nowrap",
									overflow: "hidden",
									textOverflow: "ellipsis",
									width: "100%",
								}}>
								{user ? (
									<>
										<p
											style={{
												margin: 0,
												whiteSpace: "nowrap",
												display: "inline-block",
											}}>
											* Bạn đang{" "}
											{form_type === "qa" && idEditing > 0
												? "đặt"
												: idEditing > 0 && "sửa "}
											{typeText} bằng tài khoản{" "}
										</p>
										<span
											style={{
												color: "#3A393A",
												fontWeight: 700,
												whiteSpace: "nowrap",
												overflow: "hidden",
												textOverflow: "ellipsis",
												margin: "0 0 0 4px",
											}}>
											<Tooltip
												trigger={["hover", "focus", "click"]}
												title={user?.full_name}>
												{user?.full_name}
											</Tooltip>
											{/* {name} */}
										</span>
									</>
								) : (
									`* Bạn đang ${
										form_type === "qa" && !idEditing ? "đặt" : ""
									} ${
										idEditing && idEditing > 0 ? "sửa" : ""
									} ${typeText} mà chưa đăng nhập`
								)}
								<div
									id="action_login"
									className={`${user ? "action_login_has_login" : ""}`}>
									<span
										id="span_space"
										style={{ fontWeight: 700, margin: "0 4px" }}>
										|
									</span>
									<Typography.Link onClick={handleLogin}>
										<Spin
											style={{ display: "inline-block" }}
											wrapperClassName="inline"
											indicator={
												<LoadingOutlined style={{ fontSize: 24 }} spin />
											}
											spinning={logoutResult.isLoading}>
											<span className="is_user" style={{ color: "#0186FF" }}>
												{userInfor ? "Không phải tôi" : "Đăng nhập"}
											</span>
										</Spin>
									</Typography.Link>
								</div>
							</div>
						)}
						{form_type === "review" && (
							<div>
								<Row gutter={[0, 8]}>
									<Col span={24} style={{ margin: "auto" }}>
										<CommentRate
											name="rate"
											onChangeRate={handleRateChange}
											defaultValue={modelComment ? modelComment.rate : 5}
											rules={[
												{
													required: true,
													message: "Bạn hãy đánh giá sao",
												},
											]}></CommentRate>
									</Col>
									<Col span={24}>
										<CommentInput
											bordered={true}
											style={{ ...styles.formItem }}
											maxLength={50}
											showCount={{
												formatter(arg) {
													return (
														<span>
															{arg.count}/{arg.maxLength} ký tự
														</span>
													);
												},
											}}
											styleInput={{
												border: "1px solid #D8D7D8",
												borderRadius: 4,
												height: 44,
												marginTop: 4,
											}}
											label={
												<p
													style={{
														fontWeight: 600,
														fontSize: 14,
														color: "#3A393A",
														paddingBottom: 7,
													}}>
													Tiêu đề
												</p>
											}
											name="title"
											rules={[
												{
													required: true,
													message: "Bạn chưa hoàn tất tiêu đề!",
												},
											]}
										/>
									</Col>
								</Row>
							</div>
						)}
						{DetailRender}
						{form_type === "review" && (
							<>
								<p
									style={{
										fontSize: 14,
										lineHeight: "17px",
										color: "#3A393A",
									}}>
									Hình ảnh
								</p>
								<ButtonUpload2
									initFiles={initialValue.images}
									formName="images"
									// onDeleteCompleted={}
									onUploadCompleted={handleUploadSuccess}
									rules={[
										{
											required: false,
											message: "Bạn hãy gửi hình ảnh cho chúng tối !",
										},
									]}></ButtonUpload2>
							</>
						)}
						{/* </Form.Item> */}
						{(idEditing > 0 || token === null) && (
							<Row gutter={[0, 16]} style={{ width: "100%", marginTop: 16 }}>
								{token === null && (
									<Col span={24}>
										<CommentInput
											rules={[
												{
													required: true,
													message: `Bạn chưa để lại tên viết ${typeText}!`,
												},
											]}
											style={{ ...styles.formItem }}
											label={<p style={styles.labelInput}>Tên</p>}
											name="name"
										/>
									</Col>
								)}

								<Col span={24}>
									<CommentInput
										style={{ ...styles.formItem }}
										label={<p style={styles.labelInput}>Email</p>}
										name="email"
										rules={[
											{
												type: "email",
												message: "email không đúng định dạng !",
											},
										]}
									/>
								</Col>

								<Col span={24}>
									<CommentInput
										style={{ ...styles.formItem }}
										label={<p style={styles.labelInput}>Số điện thoại</p>}
										inputMode="tel"
										name="phone"
										// pattern="[0-9]{10}"
										// title="Số điện thoại yêu cầu 10 chữ số (0-9)"
										rules={[
											// {
											//   pattern: /^\d+$/,
											//   message: "Bạn hãy nhập số nhé !",
											// },
											// {
											//   min: 10,
											//   message: "Số điện thoại yêu cầu 10 chữ số (0-9)",
											// },
											// {
											//   max: 10,
											//   message: "Số điện thoại yêu cầu 10 chữ số (0-9)",
											// },
											{
												message:
													"Số điện thoại chưa đúng định dạng. Vui lòng nhập lại",
												validateTrigger: "onSubmit",
												validator: (_, value) => {
													return new Promise((resolve, reject) => {
														if (
															value &&
															value !== "" &&
															!Helper.validatePhoneNumber(value)
														) {
															reject(".");
														} else {
															resolve(1);
														}
													});
												},
											},
										]}
									/>
								</Col>
							</Row>
						)}
						{isShowButtonSubmit && (
							<Form.Item
								id="form_submit_wrapper"
								className="form_submit_wrapper">
								<div
									className="button_submit_wrapper"
									style={{ display: "flex", gap: "9px" }}>
									<CommentButton htmlType="submit">
										{idEditing ? "Sửa" : "Gửi"} {typeText}
									</CommentButton>
									<CommentButton
										htmlType="button"
										onClick={() => {
											form.resetFields();
											handleCancelModal();
										}}>
										Hủy
									</CommentButton>
								</div>
							</Form.Item>
						)}
					</>
				</Spin>
			</Form>
			{/* <Modal
        open={showLogin}
        onCancel={() => {
          setShowLogin(false);
        }}
        title="Đổi tài khoản đăng nhập"
        width={414}
        okButtonProps={{
          style: {
            display: "none",
          },
        }}
        destroyOnClose={true}
      >
        <Login
          handleLoginSuccess={handleSwitchUserSuccess}
          handleBeforeLoginSuccess={handleBeforeLoginSuccess}
          noRegister={true}
        ></Login>
      </Modal> */}
		</>
	);
};

export default CommentForm;
